import React from 'react';
import { connect } from 'react-redux';
import Grid from '@mui/material/Grid';
import AffectationsIndicateurs from './AffectationsIndicateurs';
import { fetchUtilisateurIndicateursIfNeeded, updateUtilisateurIndicateursCriteres } from 'store/utilisateur/indicateursActions';

class AffectationsIndicateursContainer extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            selectedGroupeIndexes: [0]
        };
    }

    componentDidMount() {
        this.props.fetchUtilisateurIndicateursIfNeeded();
    }

    componentDidUpdate(prevProps) {
        if (this.props.didInvalidate && !prevProps.didInvalidate) {
            this.props.fetchUtilisateurIndicateursIfNeeded();
        }
    }

    handleChange = event => {

        let criteres = { ...this.props.criteres };
        criteres[event.target.name] = event.target.value;

        this.props.updateUtilisateurIndicateursCriteres(criteres);
    }

    handleGroupeChange = event => {        
        this.setState({ ...this.state, selectedGroupeIndexes: event.target.value.sort((a,b) => a>=b) });
    }

    render() {
        return (
            <Grid item xs={12}>
                <AffectationsIndicateurs {...this.props} selectedGroupeIndexes={this.state.selectedGroupeIndexes} onGroupeChange={this.handleGroupeChange} onChange={this.handleChange}/>
            </Grid>
        );
    }
}

const mapStateToProps = state => ({
    groupes: state.utilisateur.indicateurs.items,
    criteres: state.utilisateur.indicateurs.criteres,
    isLoading: state.utilisateur.indicateurs.isLoading,
    didInvalidate: state.utilisateur.indicateurs.didInvalidate
});

const mapDispatchToProps = dispatch => ({
    fetchUtilisateurIndicateursIfNeeded: () => dispatch(fetchUtilisateurIndicateursIfNeeded()),
    updateUtilisateurIndicateursCriteres: (criteres) => dispatch(updateUtilisateurIndicateursCriteres(criteres))
});

export default connect(mapStateToProps, mapDispatchToProps)(AffectationsIndicateursContainer);